import { LineLotState, LineLotTypes } from './types';

export const INITIAL_STATE: LineLotState = {
  lineLotData: {
    id: '',
    name: '',
    color: '#249eb2',
    createdAt: '',
    updatedAt: '',
    transportOperatorId: '',
    Lines: [],
  },
  lineLotAdded: {
    id: '',
    name: '',
    prefix: '',
    status: 0,
    visible: false,
    type: 0,
    distributionType: 0,
    lineType: 0,
    lineFunction: 0,
    model: 0,
    sector: '',
    system: '',
    operation: 0,
    color: '',
    minVelocity: 0,
    maxVelocity: 0,
    updatedAt: '',
    createdAt: '',
    lineLotId: '',
    transportOperatorId: '',
  },
  lineLotList: [],
  totalCount: 0,
  error: false,
  loading: false,
};

function createReducer(initialState = INITIAL_STATE, handlers: any) {
  return function reducer(state = initialState, action: any) {
    // eslint-disable-next-line
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}

// List Line Lot
const listLineLotRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  lineLotList: INITIAL_STATE.lineLotList,
});

const listLineLotSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  lineLotList: action.payload.lineLotList,
  totalCount: action.payload.totalCount,
});

const listLineLotFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  lineLotList: INITIAL_STATE.lineLotList,
});

// Get Line Lot
const getLineLotRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  lineLotData: INITIAL_STATE.lineLotData,
});

const getLineLotSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  lineLotData: action.payload.lineLotData,
});

const getLineLotFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  lineLotData: INITIAL_STATE.lineLotData,
});

// Filter Line Lots
const filterLineLotsRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const filterLineLotsSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
});

const filterLineLotsFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Create Line Lot
const createLineLotRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  lineLotData: INITIAL_STATE.lineLotData,
});

const createLineLotSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  lineLotData: action.payload.lineLotData,
});

const createLineLotFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  lineLotData: INITIAL_STATE.lineLotData,
});

// Add Line Lot
const addLineLotRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  lineLotAdded: INITIAL_STATE.lineLotAdded,
});

const addLineLotSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  lineLotAdded: action.payload.lineLotAdded,
});

const addLineLotFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  lineLotAdded: INITIAL_STATE.lineLotAdded,
});

// Update Line Lot
const updateLineLotRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const updateLineLotSuccess = (state: any) => ({
  ...state,
  loading: false,
  error: false,
});

const updateLineLotFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Delete Line Lot
const deleteLineLotRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const deleteLineLotSuccess = (state: any) => ({
  ...state,
  loading: false,
  error: false,
});

const deleteLineLotFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

const reducer = createReducer(INITIAL_STATE, {
  [LineLotTypes.LIST_LINE_LOT_REQUEST]: listLineLotRequest,
  [LineLotTypes.LIST_LINE_LOT_SUCCESS]: listLineLotSuccess,
  [LineLotTypes.LIST_LINE_LOT_FAILURE]: listLineLotFailure,

  [LineLotTypes.GET_LINE_LOT_REQUEST]: getLineLotRequest,
  [LineLotTypes.GET_LINE_LOT_SUCCESS]: getLineLotSuccess,
  [LineLotTypes.GET_LINE_LOT_FAILURE]: getLineLotFailure,

  [LineLotTypes.FILTER_LINE_LOTS_REQUEST]: filterLineLotsRequest,
  [LineLotTypes.FILTER_LINE_LOTS_SUCCESS]: filterLineLotsSuccess,
  [LineLotTypes.FILTER_LINE_LOTS_FAILURE]: filterLineLotsFailure,

  [LineLotTypes.CREATE_LINE_LOT_REQUEST]: createLineLotRequest,
  [LineLotTypes.CREATE_LINE_LOT_SUCCESS]: createLineLotSuccess,
  [LineLotTypes.CREATE_LINE_LOT_FAILURE]: createLineLotFailure,

  [LineLotTypes.ADD_LINE_LOT_REQUEST]: addLineLotRequest,
  [LineLotTypes.ADD_LINE_LOT_SUCCESS]: addLineLotSuccess,
  [LineLotTypes.ADD_LINE_LOT_FAILURE]: addLineLotFailure,

  [LineLotTypes.UPDATE_LINE_LOT_REQUEST]: updateLineLotRequest,
  [LineLotTypes.UPDATE_LINE_LOT_SUCCESS]: updateLineLotSuccess,
  [LineLotTypes.UPDATE_LINE_LOT_FAILURE]: updateLineLotFailure,

  [LineLotTypes.DELETE_LINE_LOT_REQUEST]: deleteLineLotRequest,
  [LineLotTypes.DELETE_LINE_LOT_SUCCESS]: deleteLineLotSuccess,
  [LineLotTypes.DELETE_LINE_LOT_FAILURE]: deleteLineLotFailure,
});

export default reducer;
